import types from '../types';

// Кожна відповідь несе ключ свого запиту (monthKey / dayKey), щоб редʼюсер міг
// відкинути відповідь, яка прийшла після того, як користувач уже перемкнув місяць чи день.
const getMonthSchedule = (payload) => ({
  type: types.schedule.GET_MONTH_SCHEDULE,
  payload,
});

const getMonthScheduleError = (payload) => ({
  type: types.schedule.GET_MONTH_SCHEDULE_ERROR,
  payload,
});

const startFetchingMonth = (payload) => ({
  type: types.schedule.START_FETCHING_MONTH,
  payload,
});

const stopFetchingMonth = (payload) => ({
  type: types.schedule.STOP_FETCHING_MONTH,
  payload,
});

const getDayEvent = (payload) => ({
  type: types.schedule.GET_DAY_EVENT,
  payload,
});

const getDayEventError = (payload) => ({
  type: types.schedule.GET_DAY_EVENT_ERROR,
  payload,
});

const startFetchingDay = (payload) => ({
  type: types.schedule.START_FETCHING_DAY,
  payload,
});

const stopFetchingDay = (payload) => ({
  type: types.schedule.STOP_FETCHING_DAY,
  payload,
});

/** Повне скидання розкладу: логаут і перехід на іншу сторінку через меню. */
const resetSchedule = () => ({
  type: types.schedule.RESET_SCHEDULE,
});

export default {
  getMonthSchedule,
  getMonthScheduleError,
  startFetchingMonth,
  stopFetchingMonth,
  getDayEvent,
  getDayEventError,
  startFetchingDay,
  stopFetchingDay,
  resetSchedule,
};
